// Copyright (c) 2017 Deere & Company

import MachineStatusUpdates from '../state/machine-status-updates';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetMachineStatusUpdates = () => getDefaultState().machineStatusUpdates;

const updateMachineStatusUpdates = (state, action) =>
    MachineStatusUpdates.update(state, {
        $set: action.data
    });

const updateMachineStatusUpdatesList = (state, action) => {

    const index = state.findIndex(item => item.id === action.id);

    return MachineStatusUpdates.update(state, {
        $splice: [
            [
                index,
                1
            ]
        ]
    });

};

export default (state = getDefaultState().machineStatusUpdates, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_MACHINE_STATUS_UPDATES]: resetMachineStatusUpdates,
        [actions.UPDATE_TCSM_MACHINE_STATUS_UPDATES]: updateMachineStatusUpdates,
        [actions.UPDATE_TCSM_MACHINE_STATUS_UPDATES_LIST]: updateMachineStatusUpdatesList
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/machine-status-updates.js